/* 🤖 this file was generated by svg-to-ts */
export const siriusCodeLightPictogram: {
  name: 'code_light_pictogram';
  data: string;
} = {
  name: 'code_light_pictogram',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" style="display: block;"><path d="M12.72 17.364 4.757 24l7.963 6.636a1.125 1.125 0 0 1-1.44 1.728l-9-7.5a1.125 1.125 0 0 1 0-1.728l9-7.5a1.125 1.125 0 0 1 1.44 1.728Zm33 5.772-9-7.5a1.125 1.125 0 0 0-1.44 1.728L43.243 24l-7.963 6.636a1.125 1.125 0 0 0 1.44 1.728l9-7.5a1.124 1.124 0 0 0 0-1.728ZM30.384 6.443a1.125 1.125 0 0 0-1.441.672l-12 33a1.126 1.126 0 0 0 2.114.77l12-33a1.125 1.125 0 0 0-.673-1.442Z" fill="currentColor"/></svg>`
};
